import { all, fork } from 'redux-saga/effects';
import { watchCreateSpaceSaga } from './create-space';
import { watchDeleteSpaceSaga } from './delete-space';
import { watchEditSpaceSaga } from './edit-space';
import { watchFetchSpaceDetailSaga } from './fetch-space';
export function* spacesRootSaga() {
    yield all([
        fork(watchCreateSpaceSaga),
        fork(watchFetchSpaceDetailSaga),
        fork(watchDeleteSpaceSaga),
        fork(watchEditSpaceSaga)
    ]);
}
